// extracted by mini-css-extract-plugin
module.exports = {"preActiveCountDown":"PreActiveCountDown_preActiveCountDown__2K7pC"};